import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import GroupEditView from "~users/components/group-edit-view-new"
import GroupListView from "~users/components/group-list-view"
import GroupAdminQueryList from "~users/components/group-query-view"
import {Typography} from '@mui/material'




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class GroupAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props;
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state
    var selectedGroupID
    if(match && match.params && match.params.id) {
      selectedGroupID = match.params.id
    }

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedGroupID) {
      view = <GroupEditView match={match} groupId={selectedGroupID} history={history} classes={{}} />
    } else {
      view = <GroupAdminQueryList></GroupAdminQueryList> 
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["group_admin"]}>
            <Typography id="groupAdminTitle" variant="h5" className={classes.heading}>
                Group Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(GroupAdmin)
